const routes = {
    '/': 'Home',
    '/cek_kartu': 'Cek Kartu',
    '/pasien': 'Data Pasien',
    '/transaksi': 'Data Transaksi',
    '/transaksi/add': 'Transaksi Baru',
    '/transaksi/detail': 'Detail Transaksi',
    '/histori_transaksi': 'Histori Transaksi',
    '/penagihan': 'Penagihan',
    '/penagihan/add': 'Request Penagihan',
    '/penagihan/edit': 'Edit Request Penagihan',
    '/tahun_ajar': 'Tahun Ajar',
    '/tahun_ajar/add': 'Tambah Tahun Ajar',
    '/tahun_ajar/edit': 'Edit Tahun Ajar',
    '/mapel': 'Mata Pelajaran',
    '/mapel/add': 'Tambah Mata Pelajaran',
    '/mapel/edit': 'Edit Mata Pelajaran',
    '/kelas': 'Kelas',
    '/kelas/media': 'Media Pass Foto',
    '/kelas/add': 'Tambah Kelas',
    '/kelas/edit': 'Edit Kelas',
    '/event': 'Event',
    '/event/add': 'Tambah Event',
    '/event/edit': 'Edit Event',
    '/news': 'Berita',
    '/news/add': 'Tambah Berita',
    '/news/edit': 'Edit Berita',
    '/news/category': 'Kategori Berita',
    '/pengumuman': 'Pengumuman',
    '/pengumuman/add': 'Tambah Pengumuman',
    '/pengumuman/edit': 'Edit Pengumuman',
    '/user-online':'User Online',
    '/prestasi': 'Prestasi',
    '/prestasi/add': 'Tambah Prestasi',
    '/prestasi/edit': 'Edit Prestasi',
    '/libur': 'Hari Libur',
    '/libur/add': 'Tambah Hari Libur',
    '/libur/edit': 'Edit Hari Libur',
    '/static-page': 'Halaman Statis',
    '/static-page/add': 'Tambah Halaman Statis',
    '/static-page/edit': 'Edit Halaman Statis',
    '/jadwal': 'Jadwal',
    '/jadwal/add': 'Tambah Jadwal',
    '/jadwal/edit': 'Edit Jadwal',
    '/users': 'Data Pengguna',
    '/users/presensi': 'Presensi Siswa',
    '/users/add': 'Tambah Data',
    '/users/edit': 'Edit Data',
    '/users/bill': 'Fee & Bill',
    '/tugas': 'Data Tugas',
    '/tugas/add': 'Tambah Tugas',
    '/tugas/edit': 'Edit Tugas',
    '/materi': 'Data Materi',
    '/materi/add': 'Tambah Materi',
    '/materi/edit': 'Edit Materi',
    
    '/setting': 'Pengaturan',

    '/spp': 'Data Spp',
    '/spp/add': 'Tambah Spp',
    '/spp/edit': 'Edit Spp',

    '/soal': 'Data Soal',
    '/soal/add': 'Tambah Soal',
    '/soal/import': 'Import Soal',
    '/soal/edit': 'Edit Soal',
    '/soal/detail': 'Detail Soal',

    '/presensi': 'Data Presensi',
    '/presensi/add': 'Tambah Presensi',
    '/presensi/edit': 'Edit Presensi',
    
    '/video': 'Data Video Belajar',
    '/video/add': 'Tambah Video Belajar',
    '/video/edit': 'Edit Video Belajar',

    '/shift': 'Jam Belajar',
    '/shift/add': 'Tambah Jam Belajar',
    '/shift/edit': 'Edit Jam Belajar',

    '/reportpresensi/nottaken' : 'Report Presensi Not Taken',
    '/reportpresensi/siswa' : 'Report Presensi Siswa',
    '/reportpresensi/guru' : 'Report Presensi Guru',
    '/reportpresensi/mapel' : 'Report Presensi Mata Pelajaran',
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js